import React from "react";
import { FaGlobe, FaExternalLinkAlt } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const WebProjects = () => {
  const webProjects = [
    // {
    //   name: "Gopiban",
    //   link: "https://www.gopiban.com/",
    //   category: "Finance",
    //   image: "/webphoto2.png",
    // },
    // {
    //   name: "Right Human",
    //   link: "https://righthuman.in/",
    //   category: "HR Tech",
    //   image: "/webphoto4.png",
    // },
    {
      name: "Gadget-e-ishq",
      link: "https://gadget-e-ishq.store/",
      category: "E-commerce",
      image: "/webphoto2.png",
    },
    {
      name: "Credence Research",
      link: "https://www.credenceresearch.com/",
      category: "Research",
      image: "/webphoto2.png",
    },
    {
      name: "Homytangs",
      link: "https://homytangs.com/",
      category: "E-commerce",
      image: "/webphoto5.png",
    },
    // {
    //   name: "Blue Mall",
    //   link: "https://bluemall.in/",
    //   category: "E-commerce",
    //   image: "/webphoto4.png",
    // },
    {
      name: "Agritss",
      link: "https://agritss.com/",
      category: "Agriculture",
      image: "/webphoto7.png",
    },
  ];

  return (
    <section className="web-projects-section" aria-label="Web Development Projects">
      <div className="section-header">
        <h2 className="section-title">Web Projects</h2>
        <p className="section-subtitle">Explore our diverse portfolio of web applications</p>
      </div>

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={30}
        slidesPerView={3}
        loop={true}
        speed={1200}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        navigation
        pagination={{ 
          clickable: true,
          dynamicBullets: true 
        }}
        breakpoints={{
          0: { 
            slidesPerView: 1.1,
            spaceBetween: 15 
          },
          480: { 
            slidesPerView: 1.4,
            spaceBetween: 20 
          },
          768: { 
            slidesPerView: 2,
            spaceBetween: 25 
          },
          1024: { 
            slidesPerView: 3,
            spaceBetween: 30 
          },
        }}
      >
        {webProjects.map((project, index) => (
          <SwiperSlide key={index}>
            <div className="project-card">
              <a
                href={project.link}
                target="_blank"
                rel="noopener noreferrer"
                className="project-link"
                aria-label={`Visit ${project.name} website`}
              >
                <div className="project-image-container">
                  <div className="image-wrap">
                    <img 
                      src={project.image} 
                      alt={`${project.name} website screenshot`} 
                      loading="lazy"
                    />
                    <div className="image-overlay">
                      <span className="view-text">View Live Site</span>
                    </div>
                  </div>
                </div>

                <div className="project-content">
                  <div className="project-header">
                    <div className="category-badge">{project.category}</div>
                    <h3 className="project-title">{project.name}</h3>
                  </div>
                  
                  <div className="project-footer">
                    <div className="website-link">
                      <FaGlobe className="link-icon" />
                      <span className="link-text">Visit Website</span>
                      <FaExternalLinkAlt className="external-icon" />
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <style jsx>{`
        .web-projects-section {
          padding: 80px 20px;
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          position: relative;
          overflow: hidden;
        }

        .section-header {
          text-align: center;
          margin-bottom: 60px;
          padding: 0 20px;
        }

        .section-title {
          font-size: 2.5rem;
          font-weight: 800;
          background: linear-gradient(135deg, #22d3ee, #3b82f6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 16px;
          letter-spacing: -0.5px;
        }

        .section-subtitle {
          color: #94a3b8;
          font-size: 1.1rem;
          max-width: 600px;
          margin: 0 auto;
          line-height: 1.6;
        }

        .project-card {
          background: rgba(255, 255, 255, 0.03);
          border: 1px solid rgba(255, 255, 255, 0.08);
          border-radius: 20px;
          overflow: hidden;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          backdrop-filter: blur(10px);
          height: 100%;
          position: relative;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
        }

        .project-card:hover {
          transform: translateY(-10px) scale(1.02);
          border-color: rgba(34, 211, 238, 0.3);
          box-shadow: 
            0 20px 40px rgba(0, 0, 0, 0.3),
            0 0 0 1px rgba(34, 211, 238, 0.1);
        }

        .project-link {
          display: block;
          text-decoration: none;
          color: inherit;
          height: 100%;
        }

        .project-image-container {
          position: relative;
          padding: 20px;
          background: rgba(0, 0, 0, 0.2);
        }

        .image-wrap {
          position: relative;
          width: 100%;
          height: 220px;
          border-radius: 12px;
          overflow: hidden;
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .image-wrap img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.6s ease;
        }

        .project-card:hover .image-wrap img {
          transform: scale(1.05);
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(
            to bottom,
            transparent 50%,
            rgba(34, 211, 238, 0.2) 100%
          );
          display: flex;
          align-items: flex-end;
          justify-content: center;
          padding: 20px;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .project-card:hover .image-overlay {
          opacity: 1;
        }

        .view-text {
          background: rgba(34, 211, 238, 0.9);
          color: white;
          padding: 10px 24px;
          border-radius: 25px;
          font-weight: 600;
          font-size: 0.9rem;
          transform: translateY(20px);
          transition: transform 0.3s ease;
        }

        .project-card:hover .view-text {
          transform: translateY(0);
        }

        .project-content {
          padding: 24px;
        }

        .project-header {
          margin-bottom: 24px;
        }

        .category-badge {
          display: inline-block;
          padding: 6px 16px;
          background: rgba(34, 211, 238, 0.1);
          color: #22d3ee;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 600;
          margin-bottom: 12px;
          border: 1px solid rgba(34, 211, 238, 0.2);
        }

        .project-title {
          font-size: 1.4rem;
          font-weight: 700;
          color: #f8fafc;
          margin: 0;
          line-height: 1.3;
        }

        .project-footer {
          border-top: 1px solid rgba(255, 255, 255, 0.05);
          padding-top: 20px;
        }

        .website-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          color: #22d3ee;
          font-weight: 600;
          font-size: 1rem;
          padding: 14px 20px;
          background: rgba(34, 211, 238, 0.1);
          border-radius: 12px;
          transition: all 0.3s ease;
          border: 1px solid transparent;
        }

        .project-card:hover .website-link {
          background: rgba(34, 211, 238, 0.15);
          border-color: rgba(34, 211, 238, 0.3);
          transform: translateY(-2px);
          box-shadow: 0 4px 15px rgba(34, 211, 238, 0.2);
        }

        .link-icon {
          font-size: 1.2rem;
        }

        .link-text {
          flex-grow: 1;
        }

        .external-icon {
          font-size: 0.9rem;
          opacity: 0.8;
        }

        /* Swiper Customization */
        :global(.swiper) {
          padding: 20px 10px 50px !important;
        }

        :global(.swiper-button-next),
        :global(.swiper-button-prev) {
          color: #22d3ee;
          background: rgba(255, 255, 255, 0.05);
          width: 50px;
          height: 50px;
          border-radius: 50%;
          border: 1px solid rgba(34, 211, 238, 0.2);
          backdrop-filter: blur(10px);
          transition: all 0.3s ease;
        }

        :global(.swiper-button-next:hover),
        :global(.swiper-button-prev:hover) {
          background: rgba(34, 211, 238, 0.1);
          border-color: #22d3ee;
          transform: scale(1.1);
          box-shadow: 0 0 20px rgba(34, 211, 238, 0.3);
        }

        :global(.swiper-button-next:after),
        :global(.swiper-button-prev:after) {
          font-size: 1.2rem;
        }

        :global(.swiper-pagination-bullet) {
          background: rgba(148, 163, 184, 0.5);
          width: 10px;
          height: 10px;
          opacity: 1;
          transition: all 0.3s ease;
        }

        :global(.swiper-pagination-bullet-active) {
          background: #22d3ee;
          width: 30px;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(34, 211, 238, 0.5);
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .web-projects-section {
            padding: 60px 15px;
          }

          .section-title {
            font-size: 2rem;
          }

          .section-subtitle {
            font-size: 1rem;
            padding: 0 10px;
          }

          .image-wrap {
            height: 180px;
          }

          .project-title {
            font-size: 1.2rem;
          }

          .website-link {
            font-size: 0.9rem;
            padding: 12px 16px;
          }
        }

        @media (max-width: 480px) {
          .web-projects-section {
            padding: 40px 10px;
          }

          .section-title {
            font-size: 1.8rem;
          }

          .image-wrap {
            height: 150px;
          }

          .project-content {
            padding: 20px;
          }

          :global(.swiper-button-next),
          :global(.swiper-button-prev) {
            width: 40px;
            height: 40px;
            display: none;
          }

          :global(.swiper-button-next:after),
          :global(.swiper-button-prev:after) {
            font-size: 1rem;
          }
        }

        @media (max-width: 360px) {
          .image-wrap {
            height: 130px;
          }

          .project-title {
            font-size: 1.1rem;
          }
        }
      `}</style>
    </section>
  );
};

export default WebProjects;